import style from './header.module.css'
import { View } from 'components/view/view.component'
import { Text } from 'components/text/text.component'
import { Icon } from 'components/icon/icon.component'
import { useAuth } from 'services/auth.service'
import { useEffect, useRef, useState } from 'react'
import { DropdownMenu } from 'components/dropdownMenu/dropdownMenu.component'
import { Button } from 'components/button/button.component'
import { useParams } from 'react-router-dom'
import { useNavigation } from 'services/navigation.service'
import { FEATURE } from 'data/features.data'
import { useGetAlertsApi } from 'api/alert.api'
import { getMonthsBefore } from 'utils/date.util'
import { Skeleton } from 'components/skeleton'

type HeaderProps = {
    title?: string,
    onMenuClick?: ()=>void,
    showAlertButton?: boolean
}

export function Header({title, onMenuClick, showAlertButton}: HeaderProps){
    const {companyId} = useParams()
    const {navigate} = useNavigation()
    const {user, logout} = useAuth()
    const [openAccountMenu, setOpenAccountMenu] = useState(false)
    const AccountButtonRef = useRef<HTMLDivElement>(null)
    const{loading: laodingAlerts, get: getAlerts, data: alerts} = useGetAlertsApi()

    useEffect(()=>{
        listAlerts()
    // eslint-disable-next-line
    }, [])

    function listAlerts(){
        const _filter = {
            companies: companyId ? [companyId] : [],
            // buildings: [],
            // indicators: [],
            startDate: getMonthsBefore(new Date(), 3),
            endDate: new Date()
        }
        getAlerts(_filter).catch(() => {})
    }

    function handleLogoutButton(){
        setOpenAccountMenu(false)
        logout()
    }

    function handleAlertClick(){
        const link = companyId ?  `/${companyId}/alertas` : `/alertas`
        navigate(link)
    }

    return <View className={style.Header}>
        <View className={`${style.Section} ${style.Left}`}>
            <View className={`${style.Menu} ${style.IconButton}`} onClick={onMenuClick}>
                <Icon>menu</Icon>
            </View>
        </View>
        <View className={`${style.Section} ${style.Center}`}>
            {title && <Text type='h3'>{title}</Text>}
        </View>
        <View className={`${style.Section} ${style.Right}`}>
            <View className={''} onClick={()=>{window.open('https://arotech.io/#faq', '_blank')}}>
                <Text>FAQ</Text>
            </View>
            {showAlertButton &&
            laodingAlerts ? <View className={style.AlertSkeleton}> <Skeleton className={style.AlertSkeleton}/> </View> :
            (alerts && alerts?.length > 0) && <View className={style.AlertButton} onClick={handleAlertClick} features={[FEATURE.ALERT_LIST.id]} >
                <Icon color='error' fontSize='small' >flag</Icon>
            </View>}
            <View className={style.AccountButton} ref={AccountButtonRef} onClick={()=>{setOpenAccountMenu(!openAccountMenu)}}>
                <Text type='h5'>{user?.name ?? user?.username ?? user?.email}</Text>
                <View className={`${style.IconButton}`}>
                    <Icon fontSize='small' baseClassName='material-icons'>account_circle</Icon>
                </View>
            </View>
            <DropdownMenu anchor={AccountButtonRef} open={openAccountMenu} shouldClose={()=>setOpenAccountMenu(false)}>
                <Button onClick={handleLogoutButton}>Logout</Button>
            </DropdownMenu>
        </View>
    </View>
}